import type { FallbackProps } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';

import { Button, Layout, Space, Typography } from 'antd';

import cls from './error-fallback.module.css';

export function ErrorFallback(props: FallbackProps) {
    const { error, resetErrorBoundary } = props;

    const { t } = useTranslation();

    return (
        <Layout>
            <Layout.Content
                className={cls.root}
                role="alert"
            >
                <Space
                    align="center"
                    direction="vertical"
                >
                    <Typography.Title level={4}>
                        {t('errorBoundaryTitle')}
                    </Typography.Title>
                    <Typography.Text>{error.message}</Typography.Text>
                    <Button
                        onClick={resetErrorBoundary}
                        type="primary"
                    >
                        {t('errorBoundaryButton')}
                    </Button>
                </Space>
            </Layout.Content>
        </Layout>
    );
}
